import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import './LanguageToggle.css';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();

  // Hide toggle on admin routes
  const isAdminRoute = location.pathname.startsWith('/admin');
  if (isAdminRoute) {
    return null;
  }

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <button 
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label={`Switch to ${language === 'en' ? 'Chinese' : 'English'}`}
    >
      <span className={`language-option ${language === 'en' ? 'active' : ''}`}>
        EN
      </span>
      <span className="language-separator">|</span>
      <span className={`language-option ${language === 'zh' ? 'active' : ''}`}>
        中文
      </span>
    </button>
  );
};

export default LanguageToggle;
